import redo from './redo';
import undo from './undo';
import saveMutation from './save-mutation';
import clearHistory from './clear-history';
import mergeHistory from './merge-history';

export default {
  redo,
  undo,
  saveMutation,
  clearHistory,
  mergeHistory,
};
